export interface ImageFormat {
  name: string;
  mime: string;
  ext: string;
}

export const formats: ImageFormat[] = [
  { name: "JPEG", mime: "image/jpeg", ext: "jpg" },
  { name: "PNG", mime: "image/png", ext: "png" },
  { name: "GIF", mime: "image/gif", ext: "gif" },
  { name: "AVIF", mime: "image/avif", ext: "avif" },
  { name: "WebP", mime: "image/webp", ext: "webp" },
  { name: "BMP", mime: "image/bmp", ext: "bmp" },
  { name: "ICO", mime: "image/x-icon", ext: "ico" },
  { name: "PDF", mime: "application/pdf", ext: "pdf" },
  { name: "TIFF", mime: "image/tiff", ext: "tiff" },
];

export const animationFormats = [
  { key: "gif", name: "GIF", mime: "image/gif", ext: "gif", preview: "image" },
  { key: "webp", name: "WebP", mime: "image/webp", ext: "webp", preview: "image" },
  { key: "avif", name: "AVIF", mime: "image/avif", ext: "avif", preview: "image" },
  { key: "apng", name: "PNG", mime: "image/apng", ext: "apng", preview: "image" },
  { key: "webm", name: "WebM", mime: "video/webm", ext: "webm", preview: "video" },
] as const;

export const previewUnsupportedMimes = new Set(["application/pdf", "image/tiff"]);

export const transparencyMimes = new Set([
  "image/png",
  "image/webp",
  "image/gif",
  "image/avif",
  "image/tiff",
  "image/x-icon",
]);

export const isPreviewable = (mime: string) => !previewUnsupportedMimes.has(mime);

export const getFileBaseName = (filename: string): string =>
  filename.replace(/\.[^/.]+$/, "") || "image";

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) {
    const kb = bytes / 1024;
    return (kb >= 10 ? Math.round(kb) : kb.toFixed(1)) + " KB";
  }
  const mb = bytes / (1024 * 1024);
  return (mb >= 10 ? Math.round(mb) : mb.toFixed(1)) + " MB";
};
